export enum DocumentLockKeyEnum {
  Order = 'order',
  Product = 'product',
  Customer = 'customer',
  Production = 'production',
  PurchaseOrder = 'purchaseOrder',
  Logistic = 'logistic',
}

export enum DocumentLockSubscriptionNameEnum {
  lockedDocument = 'lockedDocument',
  unLockedDocument = 'unLockedDocument',
}
